// TRIAGE-02 (IMP-02) — shared preset dismiss-reason chips. One source of
// truth for the Shift+X reason dialog (triage layer), the FindingsPanel
// reason popover, and the bulk-dismiss popover, so the audit-facing
// vocabulary never drifts between surfaces.
export const DISMISS_REASON_PRESETS: readonly string[] = [
  "Sun glare",
  "Reflection",
  "Dirt",
  "Duplicate",
  "Not a defect",
];
